import { Component, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BannerCardComponent } from '@shared/components/banner-card/banner-card.component';
import { IBreadcrumb } from '@shared/components/breadcrumb/breadcrumb.component';
import { ICreateEntityButtonConfiguration } from '@shared/components/create-entity-button/create-entity-button.interface';
import { CampaignsKpiCardsComponent } from './campaigns-kpi-cards/campaigns-kpi-cards.component';

@Component({
  imports: [BannerCardComponent, TranslateModule, CampaignsKpiCardsComponent],
  selector: 'app-campaigns-banner',
  templateUrl: './campaigns-banner.component.html',
})
export class CampaignsBannerComponent {
  public readonly adminMode = input<boolean>(false);
  public readonly addButtonConfiguration = input<ICreateEntityButtonConfiguration | null>(null);

  private readonly translate = inject(TranslateService);

  public readonly breadcrumbs: IBreadcrumb[] = [
    {
      label: this.translate.instant('pages.campaigns.banner.title'),
      link: '/dashboard',
    },
  ];
}
